import type { MouseEvent } from 'react';
import type { VideoProps } from 'types/videoTypes';
import { Icon } from '../Icon';
import Image from '../Image/Image';
import styles from './VideoThumbnail.module.scss';

export type VideoThumbnailProps = {
  readonly id?: string;
  readonly title: string;
  readonly kicker: string;
  readonly duration?: string;
  readonly isActive: boolean;
  readonly video: VideoProps;
  readonly onClick?: () => void;
  readonly isAdPlaying?: boolean;
};

const VideoThumbnail = ({
  id,
  title,
  kicker,
  duration,
  onClick,
  isActive = false,
  video,
  isAdPlaying,
}: VideoThumbnailProps) => {
  const handleClick = (event: MouseEvent): void => {
    event.preventDefault();
    if (typeof onClick === 'function') {
      onClick();
    }
  };

  return (
    <a
      id={id}
      onClick={handleClick}
      className={styles.main}
      aria-label={`Video abspielen: ${title}`}
      aria-current={isActive}
      href={video.url}
      role="button"
    >
      <div className={styles.poster}>
        <Image image={video.image} alt={`${title} ${kicker}`} />
        {isActive && !isAdPlaying && <div className={styles.activeIndicator}>läuft gerade</div>}
        {duration && (
          <div className={styles.duration}>
            <Icon name="play" size={16} />
            {duration}
          </div>
        )}
      </div>
      <p className={styles.title}>{title}</p>
    </a>
  );
};

export default VideoThumbnail;
